export interface VatTableItem {
    readonly vatRate: number | null;
    readonly vatRateId: number;
    netValue?: number;
    grossValue?: number;
    vatValue?: number;
}

export abstract class VatTableItemRecalculation<TVatTableItem extends VatTableItem = VatTableItem> {
    public abstract recalculate(item: TVatTableItem, precision: number, triggeredBy?: string): Readonly<Required<TVatTableItem>>;
}

export class VatTableItemRecalculationChanges {
    public static grossChanged = (propertyName: VatTableItemRecalculationChangesProperty) => /(g|G)ross/i.test(propertyName);
    public static netChanged = (propertyName: VatTableItemRecalculationChangesProperty) => /(n|N)et/i.test(propertyName);
}

export type VatTableItemRecalculationChangesProperty =
    | `${string}${'net' | 'Net'}${string}`
    | `${string}${'gross' | 'Gross'}${string}`;
